import type { Map } from '../types';

const Uris: Map = {
    TORI: 'https://assets.finn.no/pkg/@warp-ds/css/v1/tokens/tori-fi.css',
    FINN: 'https://assets.finn.no/pkg/@warp-ds/css/v1/tokens/finn-no.css',
    DBA: 'https://assets.dba.dk/pkg/@warp-ds/css/v2/tokens/dba-dk.css',
    BLOCKET: 'https://assets.blocket.se/pkg/@warp-ds/css/v2/tokens/blocket-se.css',
};

const brandToWarpCssFormatter = {
    format: String,
    name: 'brand-to-warp-css',
    /**
     * validate whether the value is a string
     * @param {any} value
     */
    validate: (value: unknown) => {
        if (typeof value !== 'string') {
            throw new Error('Value must be a String');
        }
    },
    /**
     * coerce the value to a uri to Warp CSS if valid
     * @param {string} value
     * @returns {(string | void)}
     */
    coerce: (value: string) => {
        const uri = Uris[value.toUpperCase()];
        if (uri) {
            return uri;
        }
        throw new Error(
            `Unknown brand: ${value}, I only know about ${Object.keys(Uris).join(', ')}`,
        );
    },
};

export default brandToWarpCssFormatter;
